import { useEffect } from 'react';
import { CheckCircle, Mail, Clock, Star, ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';
import { facebookPixelEvents } from '../utils/facebookPixel';

export default function PurchaseCompleteGroup() {
  useEffect(() => {
    // Facebook Pixel purchase tracking
    facebookPixelEvents.purchase({
      content_name: 'Group Business Challenge Package',
      content_category: 'Business Challenge',
      content_type: 'group_package',
      value: 149.00,
      currency: 'USD',
      num_items: 1
    });
  }, []);

  return (
    <div className="min-h-screen bg-gray-50 flex flex-col items-center justify-center p-4">
      <div className="max-w-2xl w-full bg-white rounded-lg shadow-lg p-8 text-center">
        <CheckCircle className="w-16 h-16 text-green-500 mx-auto mb-6" />
        <h1 className="text-3xl font-bold text-gray-900 mb-4">
          Group Purchase Complete!
        </h1>
        <p className="text-xl text-gray-600 mb-8">
          We're thrilled to have your group on board!
        </p>

        {/* Demo Access Section */}
        <div className="bg-blue-50 p-6 rounded-lg mb-8">
          <Star className="w-8 h-8 text-blue-500 mx-auto mb-4" />
          <h2 className="text-xl font-semibold mb-4">Start Exploring Right Away</h2>
          <p className="text-gray-600 mb-4">
            We've provided you with access to a demo account so your group can start exploring Virtual Business Challenge immediately.
          </p>
          <div className="bg-white p-4 rounded-md inline-block">
            <a href="https://play.hubro.education/join?code=hairy-loss-945" className="text-primary hover:text-primary-dark font-medium flex items-center justify-center">
              Access Demo Account <ArrowRight className="w-4 h-4 ml-2" />
            </a>
          </div>
        </div>

        {/* What to Expect Section */}
        <div className="mb-8">
          <h2 className="text-xl font-semibold mb-4">What to Expect Next</h2>
          <div className="space-y-4 text-left">
            <div className="flex items-start">
              <Clock className="w-5 h-5 text-gray-400 mt-1 mr-3 flex-shrink-0" />
              <p className="text-gray-600">
                Your group licenses will be created and activated shortly, up to 1 business day.
              </p>
            </div>
            <div className="flex items-start">
              <Mail className="w-5 h-5 text-gray-400 mt-1 mr-3 flex-shrink-0" />
              <p className="text-gray-600">
                Once ready, you'll receive an email with all the details and access instructions for all participants.
              </p>
            </div>
          </div>
        </div>

        {/* Support Section */}
        <div className="border-t pt-8">
          <h2 className="text-xl font-semibold mb-4">Need Assistance?</h2>
          <p className="text-gray-600 mb-4">
            If you have any questions about group access or need help navigating the demo, our support team is here to help:
          </p>
          <a href="mailto:contact@emploskills.com" className="text-primary hover:underline font-medium">
            contact@emploskills.com
          </a>
        </div>

        {/* Signature */}
        <div className="mt-8 pt-8 border-t">
          <p className="text-gray-600">Warm regards,</p>
          <p className="text-gray-600">The Virtual Business Challenge Team</p>
        </div>

        {/* Navigation Button */}
        <div className="mt-8">
          <Link
            to="/"
            className="block w-full bg-primary text-white rounded-md py-3 px-4 text-center font-medium hover:bg-primary-dark transition-colors"
          >
            Return to EmploSkills Homepage
          </Link>
        </div>
      </div>
    </div>
  );
} 